export const CODE_BLOCK_LINE_LIMIT = 10;

export const CODE_BLOCK_EXPAND_TESTID = 'chat.code-block.expand';

const FALLBACK_LINE_HEIGHT_PX = 20;

export const createCodeBlockExpandButton = (doc: Document, label: string): HTMLButtonElement => {
    const button = doc.createElement('button');
    button.type = 'button';
    button.className = 'code-block-expand';
    button.setAttribute('data-testid', CODE_BLOCK_EXPAND_TESTID);
    button.textContent = label;
    return button;
};

const countLines = (text: string): number => text.replace(/\n$/, '').split('\n').length;

export const annotateCodeBlocksForCollapse = (doc: Document, expandLabel: string): void => {
    doc.querySelectorAll('pre').forEach(pre => {
        const codeEl = pre.querySelector('code') ?? pre;
        const lineCount = countLines(codeEl.textContent ?? '');

        const wrapper = doc.createElement('div');
        wrapper.className = 'code-block-wrapper';
        pre.parentNode?.insertBefore(wrapper, pre);

        const scroll = doc.createElement('div');
        scroll.className = 'code-block-scroll';
        wrapper.appendChild(scroll);
        scroll.appendChild(pre);

        if (lineCount > CODE_BLOCK_LINE_LIMIT) {
            pre.classList.add('code-block-collapsed');
            const fade = doc.createElement('div');
            fade.className = 'code-block-fade';
            scroll.appendChild(fade);
            wrapper.appendChild(createCodeBlockExpandButton(doc, expandLabel));
        }
    });
};

export const sizeCollapsedCodeBlock = (pre: HTMLElement, win: Window = window): void => {
    if (pre.dataset.cbSized) return;
    pre.dataset.cbSized = '1';

    const style = win.getComputedStyle(pre);
    const lineHeightRaw = parseFloat(style.lineHeight);
    const fontSizeRaw = parseFloat(style.fontSize);
    const lineHeight = Number.isFinite(lineHeightRaw)
        ? lineHeightRaw
        : Number.isFinite(fontSizeRaw)
            ? fontSizeRaw * 1.4
            : FALLBACK_LINE_HEIGHT_PX;
    const paddingTop = parseFloat(style.paddingTop) || 0;
    const paddingBottom = parseFloat(style.paddingBottom) || 0;

    pre.style.maxHeight = `${CODE_BLOCK_LINE_LIMIT * lineHeight + paddingTop + paddingBottom}px`;
};
